export const ESTADOS_ATENCION_CONSTANTES = {
    ACTIVA: "ACTIVA",
    EN_PROCESO: "EN PROCESO",
    ATENDIDA: "ATENDIDA",
    CANCELADA: "CANCELADA",
}
